import { Attachment } from '@/modules/Upload/types'
import { ResponseArray } from '@/types/shared'
import datacentral from '@/utils/axios/datacentral'
import queryString from 'query-string'
import { SampleContract, SampleContractCreateParams } from '../types'

export const getSampleContracts = async (
    values: Record<string, any>
): Promise<ResponseArray<SampleContract>> => {
    const response = await datacentral.get<ResponseArray<SampleContract>>(
        `/contracts/samples?${queryString.stringify(values)}`
    )

    return response?.data
}

export const createContractSample = async ({
    data,
    attachments = [],
}: {
    data: SampleContractCreateParams
    attachments: Attachment[]
}) => {
    const response = await datacentral.post(`/contracts/samples`, {
        contract: data,
        attachments: attachments,
    })

    return response?.data
}
export const updateContractSample = async ({
    contractID,
    data,
    attachments = [],
    attachments_to_delete = [],
}: {
    contractID: number
    data: SampleContractCreateParams
    attachments?: Attachment[]
    attachments_to_delete?: number[]
}) => {
    const response = await datacentral.put(`/contracts/samples/${contractID}`, {
        contract: data,
        attachments: attachments,
        attachments_to_delete: attachments_to_delete,
    })

    return response?.data
}

export const getMappingContractSampleForProduct = async () => {
    const response = await datacentral.get<ResponseArray<any>>(
        `/contracts/samples/mapping`
    )

    return response?.data?.results || []
}
